import { MainContainer } from "../../components/MainContainerComp";
import { config } from "../../utils/config";

export const LinesWorkInfo = () => (
  <MainContainer hasGreyBg>
    <iframe
      id="lines"
      title="HTML Content"
      src={`${config.apiUrl}/legacy-lines-work-information`}
      style={{ width: '100%', height: 'calc(100vh - 90px)' }}
    />
  </MainContainer>
)